export default "__VITE_ASSET__uryJdeOk__"